import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import ApiService from '../../../services/apiService';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import iconsMixin from '../dtwin/state/bridge/iconsMixin';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreVirtualDeviceAddWizard',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [iconsMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    hideFields: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'DigitalTwin.VirtualDevice.wizard.createTitle'
    },
    useDriver: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      testObj: null,
      accounts: [],
      deviceGroups: [],
      deviceTypes: [],
      deviceDriversData: this.useDriver ? {
        deviceDrivers: [],
        driverSearch: null,
        searchTerm: null,
        currentPage: 0,
        driversHasNextPage: true
      } : null,
      bridgeTypes: [],
      deviceBridgesForAccount: [],
      accountTemplatesData: {
        templates: [],
        currentPage: 1,
        hasNextPage: true
      },
      deviceBridgesLoading: false,
      selectedAccount: null,
      selectedBridge: null,
      selectedTemplate: null,
      searchExternalId: null,
      // on selecting an account, fetch the first twin of that account that the user has read-access to
      // used to prefill the twin-finder with a default-value
      defaultTwinId: null,
      deviceExistsWarning: null,
      useTemplate: false,
      parentDTwin: null,
      formValid: false,
      deviceObject: null,
      markdownPreview: false,
      newDeviceGroup: '',
      numberOfWmBusVirtualDevices: 0,
      wmbusLimitExceeded: false,
      // block the input fields while a create/import request is going on
      createServerRequest: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isHeaderDataSelected: function isHeaderDataSelected() {
      return this.selectedAccount && (this.selectedBridge || this.selectedTemplate);
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      };
    },
    bridgeCanRead: function bridgeCanRead() {
      var _this2 = this;

      if (!this.selectedBridge) {
        return false;
      }

      var bridgeTypeDef = this.bridgeTypes.find(function (bridgeDef) {
        return bridgeDef.type === _this2.selectedBridge.type;
      });
      return get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read');
    },
    bridgeCreateParameters: function bridgeCreateParameters() {
      var createDeviceMethod = get(this.bridgeConfig(this.selectedBridge), 'manifest.functionScope.extension.devices.create');
      return get(this.bridgeConfig(this.selectedBridge), "manifest.commands.instance.".concat(createDeviceMethod, ".parameters.data.properties")) || {};
    },
    bridgeCreateFields: function bridgeCreateFields() {
      var _this3 = this;

      var createParameters = this.bridgeCreateParameters;
      var keys = Object.keys(createParameters).filter(function (key) {
        var visibleConfig = get(createParameters, "[".concat(key, "].visible")) || {};
        return Object.keys(visibleConfig).every(function (dependentKey) {
          return _this3.deviceObject.properties.bridge.deviceData[dependentKey] === visibleConfig[dependentKey];
        });
      });
      return keys.sort(function (a, b) {
        var orderIdxA = get(createParameters, "[".concat(a, "].orderIdx")) || 0;
        var orderIdxB = get(createParameters, "[".concat(b, "].orderIdx")) || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    templateBridgeCreateFields: function templateBridgeCreateFields() {
      var _this4 = this;

      var createParametersKeys = Object.keys(this.bridgeCreateParameters);
      return createParametersKeys.filter(function (key) {
        return !_this4.bridgeCreateParameters[key].predefineInTemplates;
      });
    },
    templateCustomProperties: function templateCustomProperties() {
      return this.selectedTemplate.deviceMeta.customProperties;
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this5 = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this5.operationalStatus[status],
          value: status
        };
      });
    },
    templateParentObject: function templateParentObject() {
      return this.parentDTwin;
    }
  }),
  watch: {
    selectedAccount: function selectedAccount() {
      this.jeffBridges(); // fetch only device-groups of vdevices that belong to this account

      this.fetchDeviceGroups();
      this.wmbusLimitExceeded = false;
    },
    selectedBridge: function selectedBridge() {
      this.deviceObject = null;
      this.wmbusLimitExceeded = false;
      this.checkWmbusLimits();
    },
    selectedTemplate: function selectedTemplate(newTemplateValue) {
      var _this6 = this;

      if (!newTemplateValue) {
        return;
      }

      this.selectedBridge = this.deviceBridgesForAccount.find(function (bridge) {
        return bridge.id === newTemplateValue.deviceMeta.connectorId;
      });
      this.deviceGroups = this.deviceGroups.map(function (group) {
        return {
          text: group,
          value: group,
          disabled: _this6.selectedTemplate.deviceMeta.groups.includes(group)
        };
      });
      ApiService.digitalTwinGet(this, this.selectedTemplate.parentId).then(function (parentDTwin) {
        _this6.parentDTwin = parentDTwin;
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.digitalTwins.twinNotFound'), 'error');
        }
      });
    },
    'deviceDriversData.driverSearch': debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newValue, oldValue) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(newValue === oldValue)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (newValue === '') {
                  this.deviceObject.data.virtualDevice.deviceDriverId = null;
                }

                this.deviceDriversData = {
                  deviceDrivers: [],
                  driverSearch: newValue,
                  searchTerm: newValue,
                  currentPage: 0,
                  driversHasNextPage: true
                };
                _context.next = 6;
                return this.fetchNextDrivers();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(), 200),
    // https://digimondo.atlassian.net/browse/RD-5760
    // Autogenerate EndDevice ID when creating Things Stack from Device EUI
    // Do not autogenerate when importing a device
    'deviceObject.properties.bridge.deviceData.dev_eui': function deviceObjectPropertiesBridgeDeviceDataDev_eui(newEui) {
      var isDeviceImport = get(this.deviceObject, 'properties.bridge.isDeviceImport');
      var isThingsStack = get(this.deviceObject, 'properties.bridge.type') === 'bridge-thingsstack';

      if (isThingsStack && !isDeviceImport) {
        this.deviceObject.properties.bridge.deviceData.device_id = "eui-".concat(newEui);
      }
    }
  },
  created: function created() {
    this.fetchAccounts();
    this.fetchDeviceTypes();
  },
  methods: {
    closeDialog: function closeDialog() {
      this.selectedAccount = null;
      this.selectedBridge = null;
      this.$emit('close');
    },
    deviceConfigChanged: function deviceConfigChanged() {
      // force a UI-refresh of the fields (dependent config fields)
      this.deviceObject = cloneDeep(this.deviceObject);
      this.wmbusLimitExceeded = false;
    },
    endDriversIntersect: function () {
      var _endDriversIntersect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(entries, observer, isIntersecting) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!isIntersecting) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.fetchNextDrivers();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function endDriversIntersect(_x3, _x4, _x5) {
        return _endDriversIntersect.apply(this, arguments);
      }

      return endDriversIntersect;
    }(),
    fetchNextDrivers: function () {
      var _fetchNextDrivers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var DRIVER_PAGE_SIZE, moreDrivers;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.deviceDriversData.driversHasNextPage || this.deviceDriversData.isLoading)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _context3.prev = 2;
                DRIVER_PAGE_SIZE = 10;
                this.deviceDriversData.isLoading = true;
                _context3.next = 7;
                return ApiService.virtualDeviceDrivers.fetch({
                  fields: 'id,title',
                  offset: this.deviceDriversData.currentPage,
                  limit: DRIVER_PAGE_SIZE,
                  search: this.deviceDriversData.searchTerm
                });

              case 7:
                moreDrivers = _context3.sent;
                this.deviceDriversData.currentPage += DRIVER_PAGE_SIZE;
                this.deviceDriversData.deviceDrivers = [].concat(_toConsumableArray(this.deviceDriversData.deviceDrivers), _toConsumableArray(moreDrivers.deviceDrivers));

                if (this.deviceDriversData.deviceDrivers.length >= moreDrivers.totalCount) {
                  this.deviceDriversData.driversHasNextPage = false;
                }

                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.wizard.fetchDriverError'), 'error');

              case 17:
                _context3.prev = 17;
                this.deviceDriversData.isLoading = false;
                return _context3.finish(17);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 13, 17, 20]]);
      }));

      function fetchNextDrivers() {
        return _fetchNextDrivers.apply(this, arguments);
      }

      return fetchNextDrivers;
    }(),
    fetchAccounts: function fetchAccounts() {
      var _this7 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        // filter the root-tenant, because that one does not have a twin to attach the new device to
        _this7.accounts = accounts.filter(function (t) {
          return !t.isRootTenant;
        });
      }).catch(function (error) {
        console.error(error);

        _this7.$snack(_this7.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    fetchDeviceTypes: function fetchDeviceTypes() {
      var _this8 = this;

      NiotaClassicApiService.deviceTypesGetPlain().then(function (res) {
        _this8.deviceTypes = res.data.devicetypes;
      }).catch(function (error) {
        _this8.$snack(_this8.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    },
    fetchDeviceGroups: function fetchDeviceGroups() {
      var _this9 = this;

      if (this.selectedAccount === null) {
        return;
      }

      ApiService.virtualDeviceFetchGroups(this, [this.selectedAccount]).then(function (res) {
        _this9.deviceGroups = res.groupList || [];
      }).catch(function (error) {
        _this9.$snack(_this9.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');

        console.error(error);
      });
    },
    // in case of an import, check if at the same account for the same bridge
    // there is a device with the same deviceId already
    findDeviceWithExternalId: function findDeviceWithExternalId() {
      var _this10 = this;

      this.deviceExistsWarning = null;
      return ApiService.virtualDeviceFetch(this, // context
      null, // userId
      [], // scopeIds
      [{
        type: 'tenantIds',
        ids: [this.selectedAccount]
      }], null, // favourite
      null, // orderBy
      0, // offset
      20, // limit
      [{
        variable: 'deviceId',
        search: this.searchExternalId
      }, {
        variable: 'bridge.type',
        search: this.selectedBridge.type
      }]).then(function (res) {
        var exists = res.virtualDevices.find(function (d) {
          return d.properties.bridge.configId === _this10.selectedBridge.id;
        });
        _this10.deviceExistsWarning = exists;

        if (!exists) {
          return _this10.importExistingDevice();
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    endTemplatesIntersect: function () {
      var _endTemplatesIntersect = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(entries, observer, isIntersecting) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!isIntersecting) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.fetchNextTemplates();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function endTemplatesIntersect(_x6, _x7, _x8) {
        return _endTemplatesIntersect.apply(this, arguments);
      }

      return endTemplatesIntersect;
    }(),
    fetchNextTemplates: function () {
      var _fetchNextTemplates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var TEMPLATE_PAGE_SIZE, moreTemplates, pageProductiveData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!this.accountTemplatesData.hasNextPage || this.accountTemplatesData.isLoading)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                _context5.prev = 2;
                TEMPLATE_PAGE_SIZE = 10;
                this.accountTemplatesData.isLoading = true;
                _context5.next = 7;
                return ApiService.deviceTemplatesFetch({
                  tenantIds: [this.selectedAccount],
                  fields: 'id,title',
                  page: this.accountTemplatesData.currentPage,
                  pageSize: TEMPLATE_PAGE_SIZE
                });

              case 7:
                moreTemplates = _context5.sent;
                this.accountTemplatesData.currentPage++;
                pageProductiveData = moreTemplates.data.map(function (td) {
                  return td.ProductiveVersion;
                });
                this.accountTemplatesData.templates = [].concat(_toConsumableArray(this.accountTemplatesData.templates), _toConsumableArray(pageProductiveData));

                if (this.accountTemplatesData.templates.length >= moreTemplates.pagination['total-count']) {
                  this.accountTemplatesData.hasNextPage = false;
                }

                _context5.next = 18;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](2);
                console.error(_context5.t0);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchError'), 'error');

              case 18:
                _context5.prev = 18;
                this.accountTemplatesData.isLoading = false;
                return _context5.finish(18);

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 14, 18, 21]]);
      }));

      function fetchNextTemplates() {
        return _fetchNextTemplates.apply(this, arguments);
      }

      return fetchNextTemplates;
    }(),
    jeffBridges: function jeffBridges() {
      var _this11 = this;

      this.deviceBridgesForAccount = [];
      this.accountTemplatesData = {
        templates: [],
        currentPage: 1,
        hasNextPage: true
      };
      this.selectedBridge = null;

      if (this.selectedAccount === null) {
        return;
      }

      this.deviceBridgesLoading = true;
      var dataPromises = [ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }), ApiService.getBridgesForTenant(this.selectedAccount), // fetch the first found twin for this account
      // is hopefully the root-twin
      ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, this.selectedAccount)];
      Promise.all(dataPromises).then(function (results) {
        _this11.bridgeTypes = results[0];
        var validDeviceBridges = results[1].filter(function (bridgeInstance) {
          var bridgeTypeDef = results[0].find(function (bridgeDef) {
            return bridgeDef.type === bridgeInstance.type;
          }); // this bridge-type must have a create-functionality
          // otherwise it should have a read to get 1 single existing device as import

          if (get(bridgeTypeDef, 'manifest.functionScope.extension.devices.create') || get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read')) {
            return true;
          }

          return false;
        });
        _this11.deviceBridgesForAccount = validDeviceBridges.map(function (bridge) {
          return bridge.state === 'active' ? bridge : _objectSpread(_objectSpread({}, bridge), {}, {
            name: "".concat(bridge.name, " (inactive)"),
            disabled: true
          });
        });
        _this11.defaultTwinId = get(results[2], 'digitaltwins[0].id', null);
        _this11.deviceBridgesLoading = false;

        _this11.fetchNextTemplates();
      }).catch(function (error) {
        _this11.deviceBridgesLoading = false;
        console.error('Error fetching bridges', error);
      });
    },
    bridgeConfig: function bridgeConfig(bridge) {
      var foundMatch = this.bridgeTypes.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    importExistingDevice: function importExistingDevice() {
      var _this12 = this;

      var bridgeTypeDef = this.bridgeTypes.find(function (bridgeDef) {
        return bridgeDef.type === _this12.selectedBridge.type;
      });
      var readMethod = get(bridgeTypeDef, 'manifest.functionScope.extension.devices.read');
      var parameterNames = Object.keys(get(bridgeTypeDef, "manifest.commands.instance.".concat(readMethod, ".parameters"), {}));
      var parameters = {};

      if (parameterNames.length >= 1) {
        parameters[parameterNames[0]] = this.searchExternalId.toLowerCase();
      }

      this.createServerRequest = true;
      ApiService.bridgeCommand(this.selectedBridge.id, readMethod, parameters).then(function (result) {
        if (!result.error && result.data) {
          _this12.createNewDevice(result.data);

          _this12.$emit('show-device-edit', _this12.deviceObject);
        } else {
          _this12.$snack(get(result, 'data.error') || result.errorMessage, 'error');
        }
      }).catch(function (error) {
        if (error.response && _this12.$i18n_t("Error.".concat(error.response.data.message))) {
          _this12.$snack(_this12.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this12.$snack(_this12.$i18n_t('DigitalTwin.VirtualDevice.snacks.createFailed'), 'error');
        }
      }).finally(function () {
        _this12.createServerRequest = false;
      });
    },
    createNewDevice: function createNewDevice() {
      var _this13 = this;

      var deviceData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (deviceData && deviceData.device_id) {
        deviceData.device_id = deviceData.device_id.toLowerCase();
      }

      this.deviceObject = {
        parentId: this.defaultTwinId,
        data: {
          keyValue: {},
          virtualDevice: {},
          tags: []
        },
        properties: {
          groups: [],
          type: 'virtualDevice',
          bridge: {
            isDeviceImport: get(deviceData, 'device_id') !== undefined,
            type: this.selectedBridge.type,
            configId: this.selectedBridge.id,
            deviceData: deviceData || {}
          }
        }
      };

      if (this.useTemplate) {
        var _this$deviceObject$da, _this$deviceObject$pr;

        (_this$deviceObject$da = this.deviceObject.data.tags).push.apply(_this$deviceObject$da, _toConsumableArray(this.selectedTemplate.deviceMeta.tags));

        (_this$deviceObject$pr = this.deviceObject.properties.groups).push.apply(_this$deviceObject$pr, _toConsumableArray(this.selectedTemplate.deviceMeta.groups));

        this.deviceObject.properties.groups.forEach(function (templateGroup) {
          if (!_this13.deviceGroups.includes(templateGroup)) {
            _this13.deviceGroups.push({
              text: templateGroup,
              value: templateGroup,
              disabled: true
            });
          }
        });
        this.deviceObject.deviceTemplateId = this.selectedTemplate.id;
        this.deviceObject.data.virtualDevice.deviceDriverId = this.selectedTemplate.deviceDriverId;
        var tempObj = {}; // v-model cannot bind keys for some reason when they are dynamically created, so temp object solved it

        Object.keys(this.templateCustomProperties).forEach(function (cpKey) {
          var defaultValue = _this13.templateCustomProperties[cpKey].defaultValue;
          tempObj[cpKey] = defaultValue ? defaultValue : undefined;
        });
        this.deviceObject.data.keyValue = tempObj;
      }
    },
    parentSelectorFilter: function parentSelectorFilter(item) {
      return (// only allow new parents from the same tenant
        item.tenantId === this.selectedAccount
      );
    },
    setTags: function setTags(a) {
      this.deviceObject.data.tags = a.tags;
    },
    addNewDeviceGroup: function addNewDeviceGroup() {
      var _this14 = this;

      var matchingGroup = this.deviceGroups.find(function (g) {
        var group = _this14.useTemplate ? g.value : g;
        return group.toLowerCase().trim() === _this14.newDeviceGroup.toLowerCase().trim();
      });

      if (!matchingGroup) {
        matchingGroup = this.newDeviceGroup.trim();
        this.deviceGroups.push(this.useTemplate ? {
          text: matchingGroup,
          value: matchingGroup
        } : matchingGroup);
      }

      this.deviceObject.properties.groups.push(matchingGroup);
      this.newDeviceGroup = '';
    },
    save: function save() {
      var _this15 = this;

      this.createServerRequest = true;
      ApiService.virtualDeviceCreate(this, this.deviceObject).then(function (res) {
        _this15.$emit('created', res);

        _this15.$snack(_this15.$i18n_t('DigitalTwin.VirtualDevice.snacks.createSuccess'), 'success');
      }).catch(function (error) {
        if (get(error, 'response.data.data.data.errors')) {
          var fieldErrors = get(error, 'response.data.data.data.errors');
          var snackText = Object.keys(fieldErrors).map(function (field) {
            return "[".concat(field, "] ").concat(fieldErrors[field]);
          });

          _this15.$snack(snackText.join('\n'), 'error');
        } else if (error.response && _this15.$i18n_te("Error.".concat(error.response.data.message))) {
          _this15.$snack(_this15.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this15.$snack(_this15.$i18n_t('DigitalTwin.VirtualDevice.snacks.createFailed'), 'error');
        }
      }).finally(function () {
        _this15.createServerRequest = false;
      });
    },
    getDependsOnFieldValue: function getDependsOnFieldValue(createFields, currentField, deviceData) {
      var dependsOnFieldName = get(createFields[currentField], 'dependsOnField');

      if (!dependsOnFieldName) {
        return null;
      }

      return deviceData[dependsOnFieldName];
    },
    restrictCharacters: function restrictCharacters(event) {
      if (event.key === ',' || event.key === ';') {
        event.preventDefault();
      }
    },
    checkWmbusLimits: function () {
      var _checkWmbusLimits = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this16 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!this.selectedBridge || this.selectedBridge.type !== 'bridge-wireless-mbus-decoder')) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                return _context6.abrupt("return", Promise.all([ApiService.fetchVirtualDevicesByBridgeType(this.selectedAccount, 'bridge-wireless-mbus-decoder'), ApiService.tenantFetchModules(this.selectedAccount)]).then(function (data) {
                  var virtualDevices = data[0];
                  var tenantModules = data[1];
                  var wmbusModule = tenantModules.find(function (m) {
                    return m.key === 'wMBus';
                  });
                  var hasActiveWmbusModule = wmbusModule.isEnabled;
                  var hasDeviceLimit = get(wmbusModule, 'settings.activeDeviceLimit');
                  var numberOfWmbusDevices = virtualDevices[0].count;
                  var limit = get(wmbusModule, 'settings.deviceLimit', 0);

                  if (!hasActiveWmbusModule || hasDeviceLimit && parseInt(numberOfWmbusDevices) >= parseInt(limit)) {
                    _this16.wmbusLimitExceeded = true;
                  }
                }).catch(function (error) {
                  console.error(error);
                }));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function checkWmbusLimits() {
        return _checkWmbusLimits.apply(this, arguments);
      }

      return checkWmbusLimits;
    }()
  }
};